import { render, staticRenderFns } from "./StrategyResult.vue?vue&type=template&id=2d7d8b71&scoped=true&"
import script from "./StrategyResult.vue?vue&type=script&lang=js&"
export * from "./StrategyResult.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d7d8b71",
  null
  
)

export default component.exports